// import axios from 'axios';
// import { useState,useEffect } from 'react';
// import { useNavigate } from 'react-router-dom'
import React from 'react'

import data from '../db'


function Techpage({
  img,category,title,desc
}) {

return (
      <>
    
    <div style={{width:"65%",height:"650px",margin:"auto"}}>
      
      <div >
          <a href="https://techcrunch.com/2022/08/26/facebook-uk-competition-class-action-proceeds/"><img style={{width:"100%"}} src={img}/></a>
      </div>

      
      <div style={{borderBottom:"4px solid #f3a342",width:"70px",marginBottom:"10px"}}>{category}</div>
      <p style={{ font: "Playfair Display",fontSize: "25px",fontWeight: "bold" }}>{title}</p>
      <div >{desc}</div>
      
  </div>
  </>
)
}

const Tech = () => {
  return (
    <>
    <p style={{marginBottom:"20px",marginTop:"30px",marginLeft:"660px",fontWeight:"600",width:"170px",fontSize:"30px",borderBottom:"5px solid #f3a342"}}>TECH NEWS</p>
    <div>
        {
          data.Tech.map(item =>
            <Techpage key={item.id} {...item}/>
            )
        }
      </div>
      </>
  )
}

export default Tech